import buildRoute from './buildRoute'

export const getUsers = async (active) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'users',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface GetUsersProps {
    active: boolean
    page?: number
    limit?: number
    filter?: any
}

export const getUsersWithLimiter = async ({
    active,
    page = 1,
    limit = 50,
    filter,
}: GetUsersProps) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'usersWithLimiter',
            data: { active, page, limit, filter },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const getUser = async (_id: object) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'user',
            data: _id,
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const addUser = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'auth-create-user',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const editUser = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'user-edit',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const archiveUsers = async (user: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'archive-user',
            data: user,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
export const deactivateUserRequest = async (userEmail: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'user-deactivation-request',
            data: { userEmail },
        })
        if (res.status) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
export const getBoatUsers = async (_id: object) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'boat-users',
            data: { _id },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface SelectionType {
    users: []
    activate: boolean
}

export const activateUsers = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'user-activations',
            data: selection,
        })
        if (res.status) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const deleteUsers = async (selection: SelectionType) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'user-deletion',
            data: selection,
        })
        if (res.status) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

interface GetUserQueryProps {
    active: boolean
    page?: number
    limit?: number
    search?: any
}
export const getUserQuery = async ({
    active,
    search = '',
    page = 1,
    limit = 20,
}: GetUserQueryProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'user-query',
            data: { active, page, limit, search },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

interface GetUserManufacturerQueryProps {
    active: boolean
    manufacturer?: String
}
export const getUsersByManufacturer = async ({
    active,
    manufacturer = '',
}: GetUserManufacturerQueryProps) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'manufacturer-users',
            data: { active, manufacturer },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

export const getUsersByDealer = async (
    active: boolean,
    assignedDealerProfile?: string
) => {
    try {
        const res: any = await buildRoute({
            type: 'post',
            route: 'dealer-users',
            data: { active, assignedDealerProfile },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        throw err
    }
}

const userRoutes = {
    getUsers,
    archiveUsers,
    getUser,
    addUser,
    activateUsers,
    editUser,
    getBoatUsers,
    deleteUsers,
    getUsersWithLimiter,
    getUserQuery,
    getUsersByDealer,
    getUsersByManufacturer,
}

export default userRoutes
